export default __webpack_public_path__ + "static/media/Frame.29c70e13.svg";